import React, { useState } from "react";
import cross from "../../assets/cross_icon.png";
import "./Login.css";
function Login({ setShowLogin }) {
  const [currentState, setCurrentState] = useState("Sign Up");
  console.log(currentState);
  return (
    <div className="login-container">
      <div className="login-body">
        <form>
          <div className="inps">
            <div className="d-flex justify-content-between">
              <h2 className="form_name">{currentState}</h2>
              <img
                className="cross-btn"
                onClick={() => setShowLogin(false)}
                src={cross}
                alt="cross btn"
              />
            </div>
            {currentState==="Sign Up" && <input
              type="text"
              placeholder="Enter Your Name"
              className="form-control"
            />}
            <input
              type="text"
              placeholder="Enter Username"
              className="form-control"
            />
            <input
              type="password"
              placeholder="Enter password"
              className="form-control"
            />
            <button className="login-btn">
              {currentState === "Sign Up" ? "Register" : "Login"}
            </button>
            {currentState === "Sign Up" ? (
              <p className="already-acc">
                Already have account?{" "}
                <span onClick={() => setCurrentState("Sign In")}>
                login here
                </span>
              </p>
            ) : (
              <p className="already-acc">
                New here?{" "}
                <span onClick={() => setCurrentState("Sign Up")}>
                  Register here
                </span>
              </p>
            )}
          </div>
        </form>
      </div>
    </div>
  );
}

export default Login;
